module.exports = __webpack_public_path__ + "static/img/trebuchet_MS_Bold.36bf970.svg";